import { createFileRoute } from "@tanstack/react-router";
import { CompareHub } from "@/components/compare-hub";
import {
  COMPARE_HUB_DESCRIPTION,
  COMPARE_HUB_LABEL,
  COMPARE_HUB_TITLE,
} from "@/config/compare";
import { compareHubHead } from "@/lib/compare-seo";
import { getMessage, loadMessages } from "@/lib/i18n";
import { getComparePages } from "@/lib/pages";
import { localeUrl } from "@/lib/seo";

export const Route = createFileRoute("/$locale/compare/")({
  loader: async ({ params }) => {
    const [pages, messages] = await Promise.all([
      getComparePages({ data: { locale: params.locale } }),
      loadMessages(params.locale, ["compare"]),
    ]);
    return {
      pages,
      title: getMessage("compare.hub.title", messages),
      description: getMessage("compare.hub.description", messages),
      compareLabel: getMessage("compare.hub.breadcrumb", messages),
    };
  },
  head: ({ params, loaderData }) =>
    compareHubHead({
      locale: params.locale,
      title: loaderData?.title ?? COMPARE_HUB_TITLE,
      description: loaderData?.description ?? COMPARE_HUB_DESCRIPTION,
      canonicalUrl: localeUrl(params.locale, "/compare"),
      homeUrl: localeUrl(params.locale, "/"),
      compareLabel: loaderData?.compareLabel ?? COMPARE_HUB_LABEL,
      pages: loaderData?.pages ?? [],
    }),
  component: function CompareIndexLocaleRoute() {
    return <CompareHub pages={Route.useLoaderData().pages} />;
  },
});
